
// Import from our single source of truth
import { APP_VERSION, BUILD_ID } from './versionManager';

// Export constants for backward compatibility
export const CACHE_VERSION = APP_VERSION;

/**
 * Enhanced mobile device detection
 */
export const getMobileDeviceInfo = () => {
  const ua = navigator.userAgent || '';
  
  // Enhanced iOS detection including iPad with modern iOS
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || 
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                
  // Android detection
  const isAndroid = /Android/i.test(ua);
  
  // General mobile detection as fallback
  const isMobileGeneric = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  
  // More reliable mobile detection using multiple methods
  const isMobile = isIOS || 
                  isAndroid || 
                  isMobileGeneric || 
                  window.innerWidth < 768 ||
                  (navigator as any).userAgentData?.mobile === true;
  
  // Browser identification
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isChrome = /chrome|chromium|crios/i.test(ua);
  const isFirefox = /firefox|fxios/i.test(ua);
  const isIE = /msie|trident/i.test(ua);
  const isEdge = /edg/i.test(ua);
  
  return {
    isMobile,
    isIOS,
    isAndroid,
    isSafari,
    isChrome,
    isFirefox,
    isIE,
    isEdge,
    userAgent: ua,
    timestamp: new Date().toISOString(),
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio || 1,
    buildId: BUILD_ID,
    appVersion: APP_VERSION
  };
};

/**
 * Sets up appropriate HTML attributes for device and platform
 */
export const setupDeviceAttributes = () => {
  const domain = window.location.hostname;
  const { isMobile, isIOS, isAndroid, isSafari } = getMobileDeviceInfo();
  
  // Set document attributes for CSS targeting
  document.documentElement.dataset.domain = domain;
  document.documentElement.dataset.mobile = String(isMobile);
  document.documentElement.dataset.ios = String(isIOS);
  document.documentElement.dataset.android = String(isAndroid);
  document.documentElement.dataset.safari = String(isSafari);
  document.documentElement.dataset.version = APP_VERSION;
  
  // Apply mobile-specific meta viewport settings
  if (isMobile) {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
      viewportMeta.setAttribute('content', 
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover'
      );
    }
  }
  
  return { domain, isMobile, isIOS, isAndroid, isSafari };
};
